var _rect, _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderEmptyIconOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FFF1DC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 36,
    r: 12,
    fill: "#FFA001"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 24.0928C34.9914 24.0316 35.492 24 36 24C42.6274 24 48 29.3726 48 36C48 42.6274 42.6274 48 36 48C29.3726 48 24 42.6274 24 36C24 33.1622 24.9851 30.5544 26.6319 28.5",
    stroke: "#003B6F",
    strokeWidth: 2.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 32V36L40 40",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0312 19.9688L32.9974 24.0026L37.0312 28.0364",
    stroke: "#003B6F",
    strokeWidth: 2.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderEmptyIconOrange);
export default __webpack_public_path__ + "static/media/OrderEmptyIconOrange.e2822e2de3ca469423f1bdbb8814f2f8.svg";
export { ForwardRef as ReactComponent };